.section {
  padding-top: calc(var(--spacer) * 3);

  .section-title {
    display: inline;
    font-size: var(--body-size-small);
    line-height: calc(var(--spacer) * 4);
    cursor: default;
    text-transform: uppercase;
    font-weight: 600;
    color: var(--chart-300-icon-buttons);
  }

  .section-items {
    gz-widget-section-with-icons-and-percentage-item:last-of-type {
      --row-border-bottom: unset;
    }
  }

  .loading-section:last-of-type {
    margin-bottom: unset;
  }
}
